//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthorizedApiClientBase } from "../../../../components/Auth/AuthorizedApiClientBase";

export class TradingClient extends AuthorizedApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getDeposit(depositId: string): Promise<GetDeposit_Response> {
        let url_ = this.baseUrl + "/api/trading/deposit/{depositId}";
        if (depositId === undefined || depositId === null)
            throw new Error("The parameter 'depositId' must be defined.");
        url_ = url_.replace("{depositId}", encodeURIComponent("" + depositId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeposit(_response);
        });
    }

    protected processGetDeposit(response: Response): Promise<GetDeposit_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDeposit_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDeposit_Response>(null as any);
    }

    /**
     * @return Success
     */
    getDepositOrder(depositId: string, orderId: string): Promise<GetDepositOrder_Response> {
        let url_ = this.baseUrl + "/api/trading/deposit/{depositId}/order/{orderId}";
        if (depositId === undefined || depositId === null)
            throw new Error("The parameter 'depositId' must be defined.");
        url_ = url_.replace("{depositId}", encodeURIComponent("" + depositId));
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDepositOrder(_response);
        });
    }

    protected processGetDepositOrder(response: Response): Promise<GetDepositOrder_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDepositOrder_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDepositOrder_Response>(null as any);
    }

    /**
     * @return Success
     */
    getRebalance(rebalanceId: string): Promise<GetRebalance_Response> {
        let url_ = this.baseUrl + "/api/trading/rebalance/{rebalanceId}";
        if (rebalanceId === undefined || rebalanceId === null)
            throw new Error("The parameter 'rebalanceId' must be defined.");
        url_ = url_.replace("{rebalanceId}", encodeURIComponent("" + rebalanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRebalance(_response);
        });
    }

    protected processGetRebalance(response: Response): Promise<GetRebalance_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRebalance_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRebalance_Response>(null as any);
    }

    /**
     * @return Success
     */
    getRebalanceOrder(rebalanceId: string, orderId: string): Promise<GetRebalanceOrder_Response> {
        let url_ = this.baseUrl + "/api/trading/rebalance/{rebalanceId}/order/{orderId}";
        if (rebalanceId === undefined || rebalanceId === null)
            throw new Error("The parameter 'rebalanceId' must be defined.");
        url_ = url_.replace("{rebalanceId}", encodeURIComponent("" + rebalanceId));
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRebalanceOrder(_response);
        });
    }

    protected processGetRebalanceOrder(response: Response): Promise<GetRebalanceOrder_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRebalanceOrder_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRebalanceOrder_Response>(null as any);
    }

    /**
     * @return Success
     */
    getWithdrawal(withdrawalId: string): Promise<GetWithdrawal_Response> {
        let url_ = this.baseUrl + "/api/trading/withdrawal/{withdrawalId}";
        if (withdrawalId === undefined || withdrawalId === null)
            throw new Error("The parameter 'withdrawalId' must be defined.");
        url_ = url_.replace("{withdrawalId}", encodeURIComponent("" + withdrawalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWithdrawal(_response);
        });
    }

    protected processGetWithdrawal(response: Response): Promise<GetWithdrawal_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWithdrawal_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetWithdrawal_Response>(null as any);
    }

    /**
     * @return Success
     */
    getWithdrawalOrder(withdrawalId: string, orderId: string): Promise<GetWithdrawalOrder_Response> {
        let url_ = this.baseUrl + "/api/trading/withdrawal/{withdrawalId}/order/{orderId}";
        if (withdrawalId === undefined || withdrawalId === null)
            throw new Error("The parameter 'withdrawalId' must be defined.");
        url_ = url_.replace("{withdrawalId}", encodeURIComponent("" + withdrawalId));
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWithdrawalOrder(_response);
        });
    }

    protected processGetWithdrawalOrder(response: Response): Promise<GetWithdrawalOrder_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWithdrawalOrder_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetWithdrawalOrder_Response>(null as any);
    }

    /**
     * Pings the trading service to avoid long cold starts
     * @return Success
     */
    warmup(): Promise<any> {
        let url_ = this.baseUrl + "/api/trading/warmup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWarmup(_response);
        });
    }

    protected processWarmup(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Get ISIN decimal place configurations
     * @param isin (optional) 
     * @return Success
     */
    adminGetIsinConfiguration(isin: string | null | undefined): Promise<AdminGetIsinConfiguration_Response> {
        let url_ = this.baseUrl + "/api/trading/admin/isin-configuration?";
        if (isin !== undefined && isin !== null)
            url_ += "isin=" + encodeURIComponent("" + isin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdminGetIsinConfiguration(_response);
        });
    }

    protected processAdminGetIsinConfiguration(response: Response): Promise<AdminGetIsinConfiguration_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminGetIsinConfiguration_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminGetIsinConfiguration_Response>(null as any);
    }

    /**
     * Update ISIN decimal place configuration
     * @return Success
     */
    adminUpdateIsinConfiguration(request: AdminUpdateIsinConfiguration_Request): Promise<AdminUpdateIsinConfiguration_Response> {
        let url_ = this.baseUrl + "/api/trading/admin/isin-configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdminUpdateIsinConfiguration(_response);
        });
    }

    protected processAdminUpdateIsinConfiguration(response: Response): Promise<AdminUpdateIsinConfiguration_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminUpdateIsinConfiguration_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminUpdateIsinConfiguration_Response>(null as any);
    }

    /**
     * @param wealthKernelPortfolioId (optional) 
     * @return Success
     */
    adminFeesGetRejectedFeeInstructionSells(wealthKernelPortfolioId: string | null | undefined): Promise<AdminFeesGetRejectedFeeInstructionSells_Response> {
        let url_ = this.baseUrl + "/api/trading/admin/fees/rejected-sells?";
        if (wealthKernelPortfolioId !== undefined && wealthKernelPortfolioId !== null)
            url_ += "wealthKernelPortfolioId=" + encodeURIComponent("" + wealthKernelPortfolioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdminFeesGetRejectedFeeInstructionSells(_response);
        });
    }

    protected processAdminFeesGetRejectedFeeInstructionSells(response: Response): Promise<AdminFeesGetRejectedFeeInstructionSells_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminFeesGetRejectedFeeInstructionSells_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminFeesGetRejectedFeeInstructionSells_Response>(null as any);
    }

    /**
     * @return Success
     */
    adminFeesPermanentlyRejectFeeSells(request: AdminFeesPermanentlyRejectFeeSells_Request): Promise<AdminFeesPermanentlyRejectFeeSells_Response> {
        let url_ = this.baseUrl + "/api/trading/admin/fees/permanently-reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdminFeesPermanentlyRejectFeeSells(_response);
        });
    }

    protected processAdminFeesPermanentlyRejectFeeSells(response: Response): Promise<AdminFeesPermanentlyRejectFeeSells_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminFeesPermanentlyRejectFeeSells_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminFeesPermanentlyRejectFeeSells_Response>(null as any);
    }

    /**
     * @return Success
     */
    adminFeesRetryRejectedFeeInstructionSells(request: AdminFeesRetryRejectedFeeInstructionSells_Request): Promise<AdminFeesRetryRejectedFeeInstructionSells_Response> {
        let url_ = this.baseUrl + "/api/trading/admin/fees/retry-rejected-sells";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdminFeesRetryRejectedFeeInstructionSells(_response);
        });
    }

    protected processAdminFeesRetryRejectedFeeInstructionSells(response: Response): Promise<AdminFeesRetryRejectedFeeInstructionSells_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminFeesRetryRejectedFeeInstructionSells_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminFeesRetryRejectedFeeInstructionSells_Response>(null as any);
    }

    /**
     * @return Success
     */
    adminFeesSubmitFeeInstruction(request: AdminFeesSubmitFeeInstruction_Request): Promise<AdminFeesSubmitFeeInstruction_Response> {
        let url_ = this.baseUrl + "/api/trading/admin/fees/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdminFeesSubmitFeeInstruction(_response);
        });
    }

    protected processAdminFeesSubmitFeeInstruction(response: Response): Promise<AdminFeesSubmitFeeInstruction_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminFeesSubmitFeeInstruction_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminFeesSubmitFeeInstruction_Response>(null as any);
    }
}

export class GetDeposit_Response implements IGetDeposit_Response {
    settledOn?: Date | undefined;
    investedOn?: Date | undefined;
    buyIds?: string[] | undefined;

    constructor(data?: IGetDeposit_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settledOn = _data["settledOn"] ? new Date(_data["settledOn"].toString()) : <any>undefined;
            this.investedOn = _data["investedOn"] ? new Date(_data["investedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["buyIds"])) {
                this.buyIds = [] as any;
                for (let item of _data["buyIds"])
                    this.buyIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDeposit_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeposit_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settledOn"] = this.settledOn ? this.settledOn.toISOString() : <any>undefined;
        data["investedOn"] = this.investedOn ? this.investedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.buyIds)) {
            data["buyIds"] = [];
            for (let item of this.buyIds)
                data["buyIds"].push(item);
        }
        return data;
    }
}

export interface IGetDeposit_Response {
    settledOn?: Date | undefined;
    investedOn?: Date | undefined;
    buyIds?: string[] | undefined;
}

/** the dto used to send an error response to the client */
export class FastEndpointsErrorResponse implements IFastEndpointsErrorResponse {
    /** the http status code sent to the client. default is 400. */
    statusCode?: number;
    /** the message for the error response */
    message?: string;
    /** the collection of errors for the current context */
    errors?: { [key: string]: string[]; };

    constructor(data?: IFastEndpointsErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusCode = 400;
            this.message = "One or more errors occurred!";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"] !== undefined ? _data["statusCode"] : 400;
            this.message = _data["message"] !== undefined ? _data["message"] : "One or more errors occurred!";
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): FastEndpointsErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FastEndpointsErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

/** the dto used to send an error response to the client */
export interface IFastEndpointsErrorResponse {
    /** the http status code sent to the client. default is 400. */
    statusCode?: number;
    /** the message for the error response */
    message?: string;
    /** the collection of errors for the current context */
    errors?: { [key: string]: string[]; };
}

export class GetDeposit_Request implements IGetDeposit_Request {

    constructor(data?: IGetDeposit_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetDeposit_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeposit_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetDeposit_Request {
}

export class GetDepositOrder_Response implements IGetDepositOrder_Response {
    isin?: string | undefined;
    dateInvested?: Date | undefined;
    orderType?: string | undefined;
    dealType?: string | undefined;
    unitQuantity?: number | undefined;
    unitPrice?: number | undefined;
    consideration?: number | undefined;

    constructor(data?: IGetDepositOrder_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isin = _data["isin"];
            this.dateInvested = _data["dateInvested"] ? new Date(_data["dateInvested"].toString()) : <any>undefined;
            this.orderType = _data["orderType"];
            this.dealType = _data["dealType"];
            this.unitQuantity = _data["unitQuantity"];
            this.unitPrice = _data["unitPrice"];
            this.consideration = _data["consideration"];
        }
    }

    static fromJS(data: any): GetDepositOrder_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetDepositOrder_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isin"] = this.isin;
        data["dateInvested"] = this.dateInvested ? this.dateInvested.toISOString() : <any>undefined;
        data["orderType"] = this.orderType;
        data["dealType"] = this.dealType;
        data["unitQuantity"] = this.unitQuantity;
        data["unitPrice"] = this.unitPrice;
        data["consideration"] = this.consideration;
        return data;
    }
}

export interface IGetDepositOrder_Response {
    isin?: string | undefined;
    dateInvested?: Date | undefined;
    orderType?: string | undefined;
    dealType?: string | undefined;
    unitQuantity?: number | undefined;
    unitPrice?: number | undefined;
    consideration?: number | undefined;
}

export class GetDepositOrder_Request implements IGetDepositOrder_Request {

    constructor(data?: IGetDepositOrder_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetDepositOrder_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetDepositOrder_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetDepositOrder_Request {
}

export class GetRebalance_Response implements IGetRebalance_Response {
    deInvestedOn?: Date | undefined;
    investedOn?: Date | undefined;
    buyIds?: string[] | undefined;
    sellIds?: string[] | undefined;
    previousAllocation?: GetRebalance_AllocationResponse[] | undefined;
    newAllocation?: GetRebalance_AllocationResponse[] | undefined;

    constructor(data?: IGetRebalance_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deInvestedOn = _data["deInvestedOn"] ? new Date(_data["deInvestedOn"].toString()) : <any>undefined;
            this.investedOn = _data["investedOn"] ? new Date(_data["investedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["buyIds"])) {
                this.buyIds = [] as any;
                for (let item of _data["buyIds"])
                    this.buyIds!.push(item);
            }
            if (Array.isArray(_data["sellIds"])) {
                this.sellIds = [] as any;
                for (let item of _data["sellIds"])
                    this.sellIds!.push(item);
            }
            if (Array.isArray(_data["previousAllocation"])) {
                this.previousAllocation = [] as any;
                for (let item of _data["previousAllocation"])
                    this.previousAllocation!.push(GetRebalance_AllocationResponse.fromJS(item));
            }
            if (Array.isArray(_data["newAllocation"])) {
                this.newAllocation = [] as any;
                for (let item of _data["newAllocation"])
                    this.newAllocation!.push(GetRebalance_AllocationResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRebalance_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetRebalance_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deInvestedOn"] = this.deInvestedOn ? this.deInvestedOn.toISOString() : <any>undefined;
        data["investedOn"] = this.investedOn ? this.investedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.buyIds)) {
            data["buyIds"] = [];
            for (let item of this.buyIds)
                data["buyIds"].push(item);
        }
        if (Array.isArray(this.sellIds)) {
            data["sellIds"] = [];
            for (let item of this.sellIds)
                data["sellIds"].push(item);
        }
        if (Array.isArray(this.previousAllocation)) {
            data["previousAllocation"] = [];
            for (let item of this.previousAllocation)
                data["previousAllocation"].push(item.toJSON());
        }
        if (Array.isArray(this.newAllocation)) {
            data["newAllocation"] = [];
            for (let item of this.newAllocation)
                data["newAllocation"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRebalance_Response {
    deInvestedOn?: Date | undefined;
    investedOn?: Date | undefined;
    buyIds?: string[] | undefined;
    sellIds?: string[] | undefined;
    previousAllocation?: GetRebalance_AllocationResponse[] | undefined;
    newAllocation?: GetRebalance_AllocationResponse[] | undefined;
}

export class GetRebalance_AllocationResponse implements IGetRebalance_AllocationResponse {
    isin?: string | undefined;
    percentage?: number;

    constructor(data?: IGetRebalance_AllocationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isin = _data["isin"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): GetRebalance_AllocationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRebalance_AllocationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isin"] = this.isin;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IGetRebalance_AllocationResponse {
    isin?: string | undefined;
    percentage?: number;
}

export class GetRebalance_Request implements IGetRebalance_Request {

    constructor(data?: IGetRebalance_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetRebalance_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetRebalance_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetRebalance_Request {
}

export class GetRebalanceOrder_Response implements IGetRebalanceOrder_Response {
    isin?: string | undefined;
    dateInvested?: Date | undefined;
    orderType?: string | undefined;
    dealType?: string | undefined;
    unitQuantity?: number | undefined;
    unitPrice?: number | undefined;
    consideration?: number | undefined;

    constructor(data?: IGetRebalanceOrder_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isin = _data["isin"];
            this.dateInvested = _data["dateInvested"] ? new Date(_data["dateInvested"].toString()) : <any>undefined;
            this.orderType = _data["orderType"];
            this.dealType = _data["dealType"];
            this.unitQuantity = _data["unitQuantity"];
            this.unitPrice = _data["unitPrice"];
            this.consideration = _data["consideration"];
        }
    }

    static fromJS(data: any): GetRebalanceOrder_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetRebalanceOrder_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isin"] = this.isin;
        data["dateInvested"] = this.dateInvested ? this.dateInvested.toISOString() : <any>undefined;
        data["orderType"] = this.orderType;
        data["dealType"] = this.dealType;
        data["unitQuantity"] = this.unitQuantity;
        data["unitPrice"] = this.unitPrice;
        data["consideration"] = this.consideration;
        return data;
    }
}

export interface IGetRebalanceOrder_Response {
    isin?: string | undefined;
    dateInvested?: Date | undefined;
    orderType?: string | undefined;
    dealType?: string | undefined;
    unitQuantity?: number | undefined;
    unitPrice?: number | undefined;
    consideration?: number | undefined;
}

export class GetRebalanceOrder_Request implements IGetRebalanceOrder_Request {

    constructor(data?: IGetRebalanceOrder_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetRebalanceOrder_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetRebalanceOrder_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetRebalanceOrder_Request {
}

export class GetWithdrawal_Response implements IGetWithdrawal_Response {
    deInvestedOn?: Date | undefined;
    sellIds?: string[] | undefined;
    settledOn?: Date | undefined;
    finalisedAmount?: number | undefined;

    constructor(data?: IGetWithdrawal_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deInvestedOn = _data["deInvestedOn"] ? new Date(_data["deInvestedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["sellIds"])) {
                this.sellIds = [] as any;
                for (let item of _data["sellIds"])
                    this.sellIds!.push(item);
            }
            this.settledOn = _data["settledOn"] ? new Date(_data["settledOn"].toString()) : <any>undefined;
            this.finalisedAmount = _data["finalisedAmount"];
        }
    }

    static fromJS(data: any): GetWithdrawal_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetWithdrawal_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deInvestedOn"] = this.deInvestedOn ? this.deInvestedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.sellIds)) {
            data["sellIds"] = [];
            for (let item of this.sellIds)
                data["sellIds"].push(item);
        }
        data["settledOn"] = this.settledOn ? this.settledOn.toISOString() : <any>undefined;
        data["finalisedAmount"] = this.finalisedAmount;
        return data;
    }
}

export interface IGetWithdrawal_Response {
    deInvestedOn?: Date | undefined;
    sellIds?: string[] | undefined;
    settledOn?: Date | undefined;
    finalisedAmount?: number | undefined;
}

export class GetWithdrawal_Request implements IGetWithdrawal_Request {

    constructor(data?: IGetWithdrawal_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetWithdrawal_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetWithdrawal_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetWithdrawal_Request {
}

export class GetWithdrawalOrder_Response implements IGetWithdrawalOrder_Response {
    isin?: string | undefined;
    dateInvested?: Date | undefined;
    orderType?: string | undefined;
    dealType?: string | undefined;
    unitQuantity?: number | undefined;
    unitPrice?: number | undefined;
    consideration?: number | undefined;

    constructor(data?: IGetWithdrawalOrder_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isin = _data["isin"];
            this.dateInvested = _data["dateInvested"] ? new Date(_data["dateInvested"].toString()) : <any>undefined;
            this.orderType = _data["orderType"];
            this.dealType = _data["dealType"];
            this.unitQuantity = _data["unitQuantity"];
            this.unitPrice = _data["unitPrice"];
            this.consideration = _data["consideration"];
        }
    }

    static fromJS(data: any): GetWithdrawalOrder_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetWithdrawalOrder_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isin"] = this.isin;
        data["dateInvested"] = this.dateInvested ? this.dateInvested.toISOString() : <any>undefined;
        data["orderType"] = this.orderType;
        data["dealType"] = this.dealType;
        data["unitQuantity"] = this.unitQuantity;
        data["unitPrice"] = this.unitPrice;
        data["consideration"] = this.consideration;
        return data;
    }
}

export interface IGetWithdrawalOrder_Response {
    isin?: string | undefined;
    dateInvested?: Date | undefined;
    orderType?: string | undefined;
    dealType?: string | undefined;
    unitQuantity?: number | undefined;
    unitPrice?: number | undefined;
    consideration?: number | undefined;
}

export class GetWithdrawalOrder_Request implements IGetWithdrawalOrder_Request {

    constructor(data?: IGetWithdrawalOrder_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetWithdrawalOrder_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetWithdrawalOrder_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetWithdrawalOrder_Request {
}

export class AdminGetIsinConfiguration_Response implements IAdminGetIsinConfiguration_Response {
    configurations?: AdminGetIsinConfiguration_Response_IsinConfigurationDto[] | undefined;

    constructor(data?: IAdminGetIsinConfiguration_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["configurations"])) {
                this.configurations = [] as any;
                for (let item of _data["configurations"])
                    this.configurations!.push(AdminGetIsinConfiguration_Response_IsinConfigurationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminGetIsinConfiguration_Response {
        data = typeof data === 'object' ? data : {};
        let result = new AdminGetIsinConfiguration_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.configurations)) {
            data["configurations"] = [];
            for (let item of this.configurations)
                data["configurations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdminGetIsinConfiguration_Response {
    configurations?: AdminGetIsinConfiguration_Response_IsinConfigurationDto[] | undefined;
}

export class AdminGetIsinConfiguration_Response_IsinConfigurationDto implements IAdminGetIsinConfiguration_Response_IsinConfigurationDto {
    isin?: string | undefined;
    decimalPlaces?: number;
    lastUpdated?: Date;
    notes?: string | undefined;

    constructor(data?: IAdminGetIsinConfiguration_Response_IsinConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isin = _data["isin"];
            this.decimalPlaces = _data["decimalPlaces"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): AdminGetIsinConfiguration_Response_IsinConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminGetIsinConfiguration_Response_IsinConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isin"] = this.isin;
        data["decimalPlaces"] = this.decimalPlaces;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IAdminGetIsinConfiguration_Response_IsinConfigurationDto {
    isin?: string | undefined;
    decimalPlaces?: number;
    lastUpdated?: Date;
    notes?: string | undefined;
}

export class AdminGetIsinConfiguration_Request implements IAdminGetIsinConfiguration_Request {

    constructor(data?: IAdminGetIsinConfiguration_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AdminGetIsinConfiguration_Request {
        data = typeof data === 'object' ? data : {};
        let result = new AdminGetIsinConfiguration_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAdminGetIsinConfiguration_Request {
}

export class AdminUpdateIsinConfiguration_Response implements IAdminUpdateIsinConfiguration_Response {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IAdminUpdateIsinConfiguration_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AdminUpdateIsinConfiguration_Response {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUpdateIsinConfiguration_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IAdminUpdateIsinConfiguration_Response {
    success?: boolean;
    message?: string | undefined;
}

export class AdminUpdateIsinConfiguration_Request implements IAdminUpdateIsinConfiguration_Request {
    isin!: string;
    decimalPlaces?: number;
    notes?: string | undefined;

    constructor(data?: IAdminUpdateIsinConfiguration_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isin = _data["isin"];
            this.decimalPlaces = _data["decimalPlaces"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): AdminUpdateIsinConfiguration_Request {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUpdateIsinConfiguration_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isin"] = this.isin;
        data["decimalPlaces"] = this.decimalPlaces;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IAdminUpdateIsinConfiguration_Request {
    isin: string;
    decimalPlaces?: number;
    notes?: string | undefined;
}

export class AdminFeesGetRejectedFeeInstructionSells_Response implements IAdminFeesGetRejectedFeeInstructionSells_Response {
    rejectedSells?: AdminFeesGetRejectedFeeInstructionSells_RejectedFeeInstructionSell[] | undefined;

    constructor(data?: IAdminFeesGetRejectedFeeInstructionSells_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rejectedSells"])) {
                this.rejectedSells = [] as any;
                for (let item of _data["rejectedSells"])
                    this.rejectedSells!.push(AdminFeesGetRejectedFeeInstructionSells_RejectedFeeInstructionSell.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminFeesGetRejectedFeeInstructionSells_Response {
        data = typeof data === 'object' ? data : {};
        let result = new AdminFeesGetRejectedFeeInstructionSells_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rejectedSells)) {
            data["rejectedSells"] = [];
            for (let item of this.rejectedSells)
                data["rejectedSells"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdminFeesGetRejectedFeeInstructionSells_Response {
    rejectedSells?: AdminFeesGetRejectedFeeInstructionSells_RejectedFeeInstructionSell[] | undefined;
}

export class AdminFeesGetRejectedFeeInstructionSells_RejectedFeeInstructionSell implements IAdminFeesGetRejectedFeeInstructionSells_RejectedFeeInstructionSell {
    feeInstructionId?: string;
    sellId?: string;
    wealthKernelPortfolioId?: string | undefined;
    requestedAmount?: number;
    createdOn?: Date;
    dateRejected?: Date | undefined;
    isin?: string | undefined;

    constructor(data?: IAdminFeesGetRejectedFeeInstructionSells_RejectedFeeInstructionSell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feeInstructionId = _data["feeInstructionId"];
            this.sellId = _data["sellId"];
            this.wealthKernelPortfolioId = _data["wealthKernelPortfolioId"];
            this.requestedAmount = _data["requestedAmount"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.dateRejected = _data["dateRejected"] ? new Date(_data["dateRejected"].toString()) : <any>undefined;
            this.isin = _data["isin"];
        }
    }

    static fromJS(data: any): AdminFeesGetRejectedFeeInstructionSells_RejectedFeeInstructionSell {
        data = typeof data === 'object' ? data : {};
        let result = new AdminFeesGetRejectedFeeInstructionSells_RejectedFeeInstructionSell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feeInstructionId"] = this.feeInstructionId;
        data["sellId"] = this.sellId;
        data["wealthKernelPortfolioId"] = this.wealthKernelPortfolioId;
        data["requestedAmount"] = this.requestedAmount;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["dateRejected"] = this.dateRejected ? this.dateRejected.toISOString() : <any>undefined;
        data["isin"] = this.isin;
        return data;
    }
}

export interface IAdminFeesGetRejectedFeeInstructionSells_RejectedFeeInstructionSell {
    feeInstructionId?: string;
    sellId?: string;
    wealthKernelPortfolioId?: string | undefined;
    requestedAmount?: number;
    createdOn?: Date;
    dateRejected?: Date | undefined;
    isin?: string | undefined;
}

export class AdminFeesGetRejectedFeeInstructionSells_Request implements IAdminFeesGetRejectedFeeInstructionSells_Request {

    constructor(data?: IAdminFeesGetRejectedFeeInstructionSells_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AdminFeesGetRejectedFeeInstructionSells_Request {
        data = typeof data === 'object' ? data : {};
        let result = new AdminFeesGetRejectedFeeInstructionSells_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAdminFeesGetRejectedFeeInstructionSells_Request {
}

export class AdminFeesPermanentlyRejectFeeSells_Response implements IAdminFeesPermanentlyRejectFeeSells_Response {
    feeInstructionId?: string;
    markedSellsCount?: number;
    markedSellIds?: string[] | undefined;
    errors?: string[] | undefined;

    constructor(data?: IAdminFeesPermanentlyRejectFeeSells_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feeInstructionId = _data["feeInstructionId"];
            this.markedSellsCount = _data["markedSellsCount"];
            if (Array.isArray(_data["markedSellIds"])) {
                this.markedSellIds = [] as any;
                for (let item of _data["markedSellIds"])
                    this.markedSellIds!.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): AdminFeesPermanentlyRejectFeeSells_Response {
        data = typeof data === 'object' ? data : {};
        let result = new AdminFeesPermanentlyRejectFeeSells_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feeInstructionId"] = this.feeInstructionId;
        data["markedSellsCount"] = this.markedSellsCount;
        if (Array.isArray(this.markedSellIds)) {
            data["markedSellIds"] = [];
            for (let item of this.markedSellIds)
                data["markedSellIds"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IAdminFeesPermanentlyRejectFeeSells_Response {
    feeInstructionId?: string;
    markedSellsCount?: number;
    markedSellIds?: string[] | undefined;
    errors?: string[] | undefined;
}

export class AdminFeesPermanentlyRejectFeeSells_Request implements IAdminFeesPermanentlyRejectFeeSells_Request {
    feeInstructionId!: string;
    sellIds!: string[];
    reason!: string;

    constructor(data?: IAdminFeesPermanentlyRejectFeeSells_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sellIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feeInstructionId = _data["feeInstructionId"];
            if (Array.isArray(_data["sellIds"])) {
                this.sellIds = [] as any;
                for (let item of _data["sellIds"])
                    this.sellIds!.push(item);
            }
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): AdminFeesPermanentlyRejectFeeSells_Request {
        data = typeof data === 'object' ? data : {};
        let result = new AdminFeesPermanentlyRejectFeeSells_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feeInstructionId"] = this.feeInstructionId;
        if (Array.isArray(this.sellIds)) {
            data["sellIds"] = [];
            for (let item of this.sellIds)
                data["sellIds"].push(item);
        }
        data["reason"] = this.reason;
        return data;
    }
}

export interface IAdminFeesPermanentlyRejectFeeSells_Request {
    feeInstructionId: string;
    sellIds: string[];
    reason: string;
}

export class AdminFeesRetryRejectedFeeInstructionSells_Response implements IAdminFeesRetryRejectedFeeInstructionSells_Response {
    feeInstructionId?: string;
    retriedSellsCount?: number;
    retriedSellIds?: string[] | undefined;
    errors?: string[] | undefined;

    constructor(data?: IAdminFeesRetryRejectedFeeInstructionSells_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feeInstructionId = _data["feeInstructionId"];
            this.retriedSellsCount = _data["retriedSellsCount"];
            if (Array.isArray(_data["retriedSellIds"])) {
                this.retriedSellIds = [] as any;
                for (let item of _data["retriedSellIds"])
                    this.retriedSellIds!.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): AdminFeesRetryRejectedFeeInstructionSells_Response {
        data = typeof data === 'object' ? data : {};
        let result = new AdminFeesRetryRejectedFeeInstructionSells_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feeInstructionId"] = this.feeInstructionId;
        data["retriedSellsCount"] = this.retriedSellsCount;
        if (Array.isArray(this.retriedSellIds)) {
            data["retriedSellIds"] = [];
            for (let item of this.retriedSellIds)
                data["retriedSellIds"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IAdminFeesRetryRejectedFeeInstructionSells_Response {
    feeInstructionId?: string;
    retriedSellsCount?: number;
    retriedSellIds?: string[] | undefined;
    errors?: string[] | undefined;
}

export class AdminFeesRetryRejectedFeeInstructionSells_Request implements IAdminFeesRetryRejectedFeeInstructionSells_Request {
    feeInstructionId!: string;
    specificSellIds?: string[] | undefined;

    constructor(data?: IAdminFeesRetryRejectedFeeInstructionSells_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feeInstructionId = _data["feeInstructionId"];
            if (Array.isArray(_data["specificSellIds"])) {
                this.specificSellIds = [] as any;
                for (let item of _data["specificSellIds"])
                    this.specificSellIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AdminFeesRetryRejectedFeeInstructionSells_Request {
        data = typeof data === 'object' ? data : {};
        let result = new AdminFeesRetryRejectedFeeInstructionSells_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feeInstructionId"] = this.feeInstructionId;
        if (Array.isArray(this.specificSellIds)) {
            data["specificSellIds"] = [];
            for (let item of this.specificSellIds)
                data["specificSellIds"].push(item);
        }
        return data;
    }
}

export interface IAdminFeesRetryRejectedFeeInstructionSells_Request {
    feeInstructionId: string;
    specificSellIds?: string[] | undefined;
}

export class AdminFeesSubmitFeeInstruction_Response implements IAdminFeesSubmitFeeInstruction_Response {
    feeId?: string;
    createdOn?: Date;
    requestedAmount?: number;

    constructor(data?: IAdminFeesSubmitFeeInstruction_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feeId = _data["feeId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.requestedAmount = _data["requestedAmount"];
        }
    }

    static fromJS(data: any): AdminFeesSubmitFeeInstruction_Response {
        data = typeof data === 'object' ? data : {};
        let result = new AdminFeesSubmitFeeInstruction_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feeId"] = this.feeId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["requestedAmount"] = this.requestedAmount;
        return data;
    }
}

export interface IAdminFeesSubmitFeeInstruction_Response {
    feeId?: string;
    createdOn?: Date;
    requestedAmount?: number;
}

export class AdminFeesSubmitFeeInstruction_Request implements IAdminFeesSubmitFeeInstruction_Request {
    feeId?: string | undefined;
    wealthKernelPortfolioId!: string;
    amount?: number;

    constructor(data?: IAdminFeesSubmitFeeInstruction_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feeId = _data["feeId"];
            this.wealthKernelPortfolioId = _data["wealthKernelPortfolioId"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): AdminFeesSubmitFeeInstruction_Request {
        data = typeof data === 'object' ? data : {};
        let result = new AdminFeesSubmitFeeInstruction_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feeId"] = this.feeId;
        data["wealthKernelPortfolioId"] = this.wealthKernelPortfolioId;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IAdminFeesSubmitFeeInstruction_Request {
    feeId?: string | undefined;
    wealthKernelPortfolioId: string;
    amount?: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}